module.exports = __webpack_public_path__ + "img/pdf-icon.7a157a1a.jpg";